import { Component, Input, OnInit } from "@angular/core";
import {
  NbCardModule,
  NbDatepickerModule,
  NbDialogRef,
  NbIconModule,
  NbInputModule,
  NbOptionModule,
  NbSelectModule,
} from "@nebular/theme";
import { EmployeeSecondingService } from "../employee-seconding.service";
import { ReactiveFormsModule } from "@angular/forms";
import { AsyncPipe, NgForOf, NgIf } from "@angular/common";
import { IDelegateEmployeeRequest } from "../employee.model";

@Component({
  selector: "empoloyee-seconding-dialog",
  templateUrl: "./employee-seconding-dialog.component.html",
  styleUrls: ["./employee-seconding-dialog.component.scss"],
  standalone: true,
  imports: [
    NbIconModule,
    NbInputModule,
    ReactiveFormsModule,
    NbOptionModule,
    NbSelectModule,
    NgForOf,
    NgIf,
    AsyncPipe,
    NbDatepickerModule,
    NbCardModule,
  ],
})
export class EmployeeSecondingDialogComponent implements OnInit {
  @Input()
  employeeUid: string = "";
  @Input()
  isSend: boolean = true;

  @Input()
  careHomeId?: number;
  @Input()
  dateStart?: string;
  @Input()
  dateEnd?: string;

  @Input()
  title: string = "";

  form = this.employeeSecondingService.createSecondingForm(this.isSend);

  careHomes = this.employeeSecondingService.careHomesState;

  constructor(
    protected ref: NbDialogRef<EmployeeSecondingDialogComponent>,
    protected employeeSecondingService: EmployeeSecondingService,
  ) {
    this.employeeSecondingService.getCareHomes();
  }

  ngOnInit() {
    this.form = this.employeeSecondingService.createSecondingForm(
      this.isSend,
      this.careHomeId,
      this.dateStart,
      this.dateEnd,
    );
  }

  close() {
    this.ref.close(false);
  }

  save() {
    this.employeeSecondingService
      .saveSeconding(this.employeeUid, {
        dateEnd: null,
        dateStart: null,
        targetCareHomeId: 0,
        ...this.form.value,
      } as IDelegateEmployeeRequest)
      .subscribe(() => {
        this.ref.close(true);
      });
  }
}
